import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, retry, switchMap, timer } from 'rxjs';
import { AppInfo } from '../../global/environment';
import { ClientList } from '../../global/environment/environment.type';
import { UserService } from '../services/user.service';

export enum HeaderNames {
  REQUEST_SOURCE = 'request-source',
  REQUEST_ACTION = 'request-action',
  CLIENT = 'wl-client',
}

// Backend whitelabel client identifiers, matching the my-account apps' per-brand config
const WL_CLIENT_BY_BRAND: Record<ClientList, string> = {
  DG: 'DandGUK',
  AO: 'AOCARE',
  Hoover: 'HOOVERWLUK',
  Sky: 'SKYPUK',
};

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(AppInfo.Environment.myAccountAPI)) {
    const brand = AppInfo.Environment.client;
    const myAccountClient = WL_CLIENT_BY_BRAND[brand];
    req = req.clone({
      setHeaders: {
        [HeaderNames.REQUEST_SOURCE]: myAccountClient,
        [HeaderNames.REQUEST_ACTION]: 'MyAccount',
        [HeaderNames.CLIENT]: myAccountClient,
      },
    });
  }

  if (req.url.includes(AppInfo.Environment.api)) {
    const wlClient = WL_CLIENT_BY_BRAND[AppInfo.Environment.client];
    req = req.clone({
      setHeaders: {
        [HeaderNames.REQUEST_SOURCE]: wlClient,
        [HeaderNames.CLIENT]: wlClient,
      },
    });
  }

  if (req.url.includes(AppInfo.Environment.claimsApiV2)) {
    req = req.clone({
      setHeaders: {
        [HeaderNames.REQUEST_SOURCE]: 'DandGUK',
        [HeaderNames.REQUEST_ACTION]: 'QandB',
        [HeaderNames.CLIENT]: 'DandGUK',
      },
    });
  }

  const userToken = inject(UserService).userToken;

  return userToken.pipe(
    switchMap((token) => {
      let headers = req.headers
        .append('Authorization', `Bearer ${token as string}`)
        .append('accept', 'application/json')
        .append('Content-Type', 'application/json')
        .append('Request-Client', WL_CLIENT_BY_BRAND[AppInfo.Environment.client]);

      let newReq = req.clone({
        headers: headers,
      });

      if (req.url.includes('/signout') || req.url.includes(AppInfo.Environment.claimsApiV2)) {
        headers = req.headers.append('accept', 'application/json').append('Content-Type', 'application/json');
        newReq = req.clone({
          headers: headers,
          withCredentials: true,
        });
      }

      return next(newReq).pipe(
        retry({
          count: 2,
          delay: (error) => {
            if (
              error.status === 0 ||
              error.status === HttpStatusCode.GatewayTimeout ||
              error.status === HttpStatusCode.RequestTimeout
            ) {
              return timer(300);
            }
            throw error;
          },
        }),
        catchError((err) => {
          if (err.status === HttpStatusCode.Unauthorized || err.status === HttpStatusCode.Forbidden) {
            document.location.href = `${AppInfo.Environment.myAccountURL}/logout`;
          }
          throw err;
        })
      );
    })
  );
};
